// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".datetime .dropdown-content {\n  width: 25%;\n}\n.datetime .dropdown-content .field-body .field {\n    flex-direction: row-reverse;\n}\n", ""]);
// Exports
module.exports = exports;
